export const translations = {
  en: {
	langid : 'en',
	title : "Free Video Downloader Online – Download Videos Fast | Grab&amp;Watch",
	desc : "Download videos online for free with Grabw.com. Fast, easy, HD quality video downloader for TikTok, Instagram, Threads, Facebook, X, YouTube Shorts, Popweb, VidGF, Vidara, Doodstream and more.",
	keywords : "video downloader, youtube downloader, instagram downloader, tiktok downloader, facebook video download, twitter video download, doodstream downloader, download video online, free video downloader, mp4 downloader, no watermark, 4k video download, download tiktok no watermark",
    // Navbar
    nav: {
      features: 'Features',
      platforms: 'Platforms',
      howItWorks: 'How It Works',
      faq: 'FAQ',
      tryPro: 'Try Pro',
    },

    // Hero
    hero: {
      badge: 'Free & Unlimited Downloads',
      headline1: 'Download Videos from',
      headline2: 'Any Platform',
      subheadline: 'Paste a link from YouTube, Instagram, Threads, TikTok, Facebook, X/Twitter, or Doodstream — ready to download in seconds.',
      placeholder: {
        all: 'Paste video link from any platform...',
        youtube: 'https://youtube.com/watch?v=...',
        instagram: 'https://instagram.com/p/...',
        threads: 'https://threads.com/...',
        facebook: 'https://facebook.com/watch?v=...',
        tiktok: 'https://tiktok.com/@user/video/...',
        twitter: 'https://x.com/user/status/...',
        doodstream: 'https://dood.watch/d/...',
      },
      pasteBtn: 'Paste',
      downloadBtn: 'Download',
      hint: 'Supports MP4 · MP3 · WebM · Up to 4K · No watermark',
      supportedLabel: 'Supported Platforms',
      stats: [
        { num: '10M+', label: 'Videos Downloaded' },
        { num: '7', label: 'Platforms Supported' },
        { num: '4K', label: 'Max Resolution' },
        { num: '100%', label: 'Free Forever' },
      ],
      toastPaste: '✓ Link pasted successfully',
      toastPasteAlt: 'Use Ctrl+V to paste',
      toastEmpty: '⚠ Please enter a video link first',
      toastInvalid: '⚠ Link must start with https://',
      toastSuccess: '✓ Downloading video...',
    },

    // Progress Modal
    modal: {
      title: 'Downloader',
      stages: ['Analyzing link...', 'Fetching video info...', 'Video ready to download!'],
      formatLabel: 'Select Format',
      downloadBtn: 'Download',
    },

    // Features
    features: {
      sectionBadge: 'Why GrabWatch?',
      headline: 'All Features, Completely Free',
      sub: 'Everything you need to download videos, at no cost.',
      items: [
        { title: 'High Resolution', desc: 'Download up to 4K, 1080p, 720p quality as needed' },
        { title: 'Multi Format', desc: 'Choose MP4, MP3, WebM, or other formats' },
        { title: 'No Watermark', desc: 'Clean video without any logos or marks' },
        { title: 'No Registration', desc: 'Use it directly, no account or login required' },
        { title: 'Fast Downloads', desc: 'Server optimized for maximum speed' },
        { title: '100% Free', desc: 'All features free forever, no paid ads' },
      ],
    },

    // How It Works
    howItWorks: {
      sectionBadge: 'How It Works',
      headline: 'Just 4 Simple Steps',
      steps: [
        {
          num: '01', title: 'Copy Video Link',
          desc: 'Open your favorite platform, find the video you want, then copy the URL from the address bar or share button.',
        },
        {
          num: '02', title: 'Paste in GrabWatch',
          desc: 'Click the input box above, paste your video link, and GrabWatch will auto-detect the platform and available formats.',
        },
        {
          num: '03', title: 'Choose Format & Quality',
          desc: 'Select resolution and format: MP4 4K for best quality, MP3 for audio only, or other available formats.',
        },
        {
          num: '04', title: 'Download & Enjoy',
          desc: 'Click download and the file saves directly to your device. Clean, fast, no watermark, no sign-up required.',
        },
      ],
    },

    // FAQ
    faq: {
      sectionBadge: 'FAQ',
      headline: 'Frequently Asked Questions',
      items: [
        {
          q: 'Is GrabWatch really free?',
          a: 'Yes, GrabWatch is 100% free for all users. No hidden fees, no subscriptions required, and no ads blocking the download process.',
        },
        {
          q: 'Which platforms are supported?',
          a: 'GrabWatch supports YouTube, Instagram (Reels, Stories, Posts), Threads, Facebook, X/Twitter, TikTok, and Doodstream. We are continuously adding new platforms.',
        },
        {
          q: 'Do I need to create an account or login?',
          a: 'No registration needed. Just paste the video link and download immediately. We do not store personal data or download history.',
        },
        {
          q: 'What formats and resolutions are available?',
          a: 'Available formats: MP4 (4K/1080p/720p/480p/360p), MP3 (320kbps/192kbps/128kbps), and WebM. Availability depends on the original video.',
        },
        {
          q: 'Can I download private videos?',
          a: 'No. GrabWatch can only download publicly available content. Private videos or those requiring login cannot be accessed.',
        },
        {
          q: 'Is there a download limit?',
          a: 'The free version has no strict daily limit. However, for optimal performance and batch download features, a Pro plan is available.',
        },
      ],
    },

    // Footer
    footer: {
      tagline: 'Download videos from your favorite platforms, free, fast, and secure.',
      columns: [
        {
          title: 'Platforms',
          links: ['YouTube', 'Instagram', ' Threads', 'Facebook', 'TikTok', 'X / Twitter', 'Doodstream'],
        },
        {
          title: 'Product',
          links: ['Chrome Extension', 'Pro Version', 'API Docs', 'Changelog'],
        },
        {
          title: 'Help',
          links: ['Guide', 'FAQ', 'Server Status', 'Contact Us'],
        },
      ],
      copyright: '© 2025 GrabWatch. Built with ❤ for internet users worldwide.',
      legal: ['Privacy', 'Terms & Conditions', 'Cookie'],
    },

    // Language toggle
    lang: { toggle: 'ID', label: 'English' },
  },

  id: {
	langid : 'id',
	title: "Pengunduh Video Gratis Online – Unduh Video Cepat | Grab&Watch",
	desc: "Unduh video online gratis dengan Grabw.com. Pengunduh video cepat, mudah, dan berkualitas HD untuk TikTok, Instagram, Threads, Facebook, X, YouTube Shorts, Popweb, VidGF, Vidara, Doodstream, dan lainnya.",
	keywords: "pengunduh video, pengunduh youtube, pengunduh instagram, pengunduh tiktok, unduh video facebook, unduh video twitter, pengunduh doodstream, unduh video online, pengunduh video gratis, pengunduh mp4, tanpa watermark, unduh video 4k, unduh tiktok tanpa watermark",
    nav: {
      features: 'Fitur',
      platforms: 'Platform',
      howItWorks: 'Cara Kerja',
      faq: 'FAQ',
      tryPro: 'Coba Pro',
    },

    hero: {
      badge: 'Gratis & Tanpa Batas Unduhan',
      headline1: 'Unduh Video dari',
      headline2: 'Platform Mana Saja',
      subheadline: 'Paste link dari YouTube, Instagram, Threads, TikTok, Facebook, X/Twitter, atau Doodstream — siap diunduh dalam hitungan detik.',
      placeholder: {
        all: 'Paste link video dari platform manapun...',
        youtube: 'https://youtube.com/watch?v=...',
        instagram: 'https://instagram.com/p/...',
        threads: 'https://threads.com/...',
        facebook: 'https://facebook.com/watch?v=...',
        tiktok: 'https://tiktok.com/@user/video/...',
        twitter: 'https://x.com/user/status/...',
        doodstream: 'https://dood.watch/d/...',
      },
      pasteBtn: 'Paste',
      downloadBtn: 'Unduh',
      hint: 'Mendukung MP4 · MP3 · WebM · Hingga 4K · Tanpa watermark',
      supportedLabel: 'Platform yang Didukung',
      stats: [
        { num: '10M+', label: 'Video Diunduh' },
        { num: '7', label: 'Platform Didukung' },
        { num: '4K', label: 'Resolusi Maks' },
        { num: '100%', label: 'Gratis Selamanya' },
      ],
      toastPaste: '✓ Link berhasil di-paste',
      toastPasteAlt: 'Gunakan Ctrl+V untuk paste',
      toastEmpty: '⚠ Masukkan link video terlebih dahulu',
      toastInvalid: '⚠ Link harus dimulai dengan https://',
      toastSuccess: '✓ Mengunduh video...',
    },

    modal: {
      title: 'Downloader',
      stages: ['Menganalisis link...', 'Mengambil informasi video...', 'Video siap diunduh!'],
      formatLabel: 'Pilih Format',
      downloadBtn: 'Unduh',
    },

    features: {
      sectionBadge: 'Kenapa GrabWatch?',
      headline: 'Fitur Lengkap, Gratis Semua',
      sub: 'Semua yang kamu butuhkan untuk mengunduh video, tanpa biaya.',
      items: [
        { title: 'Resolusi Tinggi', desc: 'Unduh hingga kualitas 4K, 1080p, 720p sesuai kebutuhan' },
        { title: 'Multi Format', desc: 'Pilih MP4, MP3, WebM, atau format lainnya' },
        { title: 'Tanpa Watermark', desc: 'Video bersih tanpa logo atau tanda apapun' },
        { title: 'Tanpa Registrasi', desc: 'Langsung pakai, tidak perlu akun atau login' },
        { title: 'Unduhan Cepat', desc: 'Server dioptimalkan untuk kecepatan maksimal' },
        { title: '100% Gratis', desc: 'Semua fitur gratis selamanya, tanpa iklan berbayar' },
      ],
    },

    howItWorks: {
      sectionBadge: 'Cara Kerja',
      headline: 'Hanya 4 Langkah Mudah',
      steps: [
        {
          num: '01', title: 'Copy Link Video',
          desc: 'Buka platform favoritmu, temukan video yang ingin diunduh, lalu copy URL-nya dari address bar atau tombol share.',
        },
        {
          num: '02', title: 'Paste di GrabWatch',
          desc: 'Klik kotak input di atas, paste link videomu, dan GrabWatch akan otomatis mendeteksi platform serta format yang tersedia.',
        },
        {
          num: '03', title: 'Pilih Format & Kualitas',
          desc: 'Pilih resolusi dan format sesuai kebutuhan: MP4 4K untuk kualitas terbaik, MP3 untuk audio saja, atau format lainnya.',
        },
        {
          num: '04', title: 'Unduh & Nikmati',
          desc: 'Klik tombol unduh dan file langsung tersimpan ke perangkatmu. Bersih, cepat, tanpa watermark, tanpa daftar.',
        },
      ],
    },

    faq: {
      sectionBadge: 'FAQ',
      headline: 'Pertanyaan Umum',
      items: [
        {
          q: 'Apakah GrabWatch benar-benar gratis?',
          a: 'Ya, GrabWatch 100% gratis untuk semua pengguna. Tidak ada biaya tersembunyi, tidak perlu berlangganan, dan tidak ada iklan yang menghalangi proses unduhan.',
        },
        {
          q: 'Platform apa saja yang didukung?',
          a: 'GrabWatch mendukung YouTube, Instagram (Reels, Stories, Post), Threads, Facebook, X/Twitter, TikTok, dan Doodstream. Kami terus menambahkan platform baru.',
        },
        {
          q: 'Apakah perlu membuat akun atau login?',
          a: 'Tidak perlu. Cukup paste link video dan langsung unduh. Kami tidak menyimpan data pribadi atau riwayat unduhan kamu.',
        },
        {
          q: 'Format dan resolusi apa saja yang tersedia?',
          a: 'Tersedia MP4 (4K/1080p/720p/480p/360p), MP3 (320kbps/192kbps/128kbps), dan WebM. Ketersediaan format tergantung video aslinya.',
        },
        {
          q: 'Apakah bisa mengunduh video privat?',
          a: 'Tidak. GrabWatch hanya bisa mengunduh konten yang tersedia secara publik. Video privat atau yang memerlukan login tidak dapat diakses.',
        },
        {
          q: 'Apakah ada batasan jumlah unduhan?',
          a: 'Versi gratis tidak memiliki batas harian yang ketat. Namun untuk performa optimal dan fitur batch download, tersedia paket Pro.',
        },
      ],
    },

    footer: {
      tagline: 'Unduh video dari platform favorit secara gratis, cepat, dan aman.',
      columns: [
        {
          title: 'Platform',
          links: ['YouTube', 'Instagram', 'Threads', 'Facebook', 'TikTok', 'X / Twitter', 'Doodstream'],
        },
        {
          title: 'Produk',
          links: ['Ekstensi Chrome', 'Versi Pro', 'API Docs', 'Changelog'],
        },
        {
          title: 'Bantuan',
          links: ['Panduan', 'FAQ', 'Status Server', 'Hubungi Kami'],
        },
      ],
      copyright: '© 2025 GrabWatch. Dibuat dengan ❤ untuk pengguna internet Indonesia.',
      legal: ['Privasi', 'Syarat & Ketentuan', 'Cookie'],
    },

    lang: { toggle: 'EN', label: 'Indonesia' },
  },
  // Vietnam
	vi: {
	  langid : 'vi',
	  title: "Trình Tải Video Miễn Phí Trực Tuyến – Tải Video Nhanh | Grab&Watch",
	  desc: "Tải video trực tuyến miễn phí với Grabw.com. Trình tải video nhanh, dễ sử dụng, chất lượng HD cho TikTok, Instagram, Threads, Facebook, X, YouTube Shorts, Popweb, VidGF, Vidara, Doodstream và nhiều nền tảng khác.",
	  keywords: "trình tải video, tải youtube, tải instagram, tải tiktok, tải video facebook, tải video twitter, tải doodstream, tải video trực tuyến, tải video miễn phí, tải mp4, không watermark, tải video 4k, tải tiktok không watermark",

	  nav: {
		features: 'Tính năng',
		platforms: 'Nền tảng',
		howItWorks: 'Cách hoạt động',
		faq: 'FAQ',
		tryPro: 'Dùng thử Pro',
	  },

	  hero: {
		badge: 'Tải xuống miễn phí & không giới hạn',
		headline1: 'Tải video từ',
		headline2: 'Mọi nền tảng',
		subheadline: 'Dán liên kết từ YouTube, Instagram, Threads, TikTok, Facebook, X/Twitter hoặc Doodstream — sẵn sàng tải xuống trong vài giây.',
		placeholder: {
		  all: 'Dán liên kết video từ bất kỳ nền tảng nào...',
		  youtube: 'https://youtube.com/watch?v=...',
		  instagram: 'https://instagram.com/p/...',
		  threads: 'https://threads.com/...',
		  facebook: 'https://facebook.com/watch?v=...',
		  tiktok: 'https://tiktok.com/@user/video/...',
		  twitter: 'https://x.com/user/status/...',
		  doodstream: 'https://dood.watch/d/...',
		},
		pasteBtn: 'Dán',
		downloadBtn: 'Tải xuống',
		hint: 'Hỗ trợ MP4 · MP3 · WebM · Lên tới 4K · Không watermark',
		supportedLabel: 'Nền tảng được hỗ trợ',
		stats: [
		  { num: '10M+', label: 'Video đã tải' },
		  { num: '7', label: 'Nền tảng hỗ trợ' },
		  { num: '4K', label: 'Độ phân giải tối đa' },
		  { num: '100%', label: 'Miễn phí mãi mãi' },
		],
		toastPaste: '✓ Đã dán liên kết thành công',
		toastPasteAlt: 'Sử dụng Ctrl+V để dán',
		toastEmpty: '⚠ Vui lòng nhập liên kết video trước',
		toastInvalid: '⚠ Liên kết phải bắt đầu bằng https://',
		toastSuccess: '✓ Đang tải video...',
	  },

	  modal: {
		title: 'Downloader',
		stages: [
		  'Đang phân tích liên kết...',
		  'Đang lấy thông tin video...',
		  'Video đã sẵn sàng để tải!'
		],
		formatLabel: 'Chọn định dạng',
		downloadBtn: 'Tải xuống',
	  },

	  features: {
		sectionBadge: 'Tại sao chọn GrabWatch?',
		headline: 'Tất cả tính năng hoàn toàn miễn phí',
		sub: 'Mọi thứ bạn cần để tải video, hoàn toàn miễn phí.',
		items: [
		  { title: 'Độ phân giải cao', desc: 'Tải xuống tới 4K, 1080p, 720p theo nhu cầu' },
		  { title: 'Nhiều định dạng', desc: 'Chọn MP4, MP3, WebM hoặc các định dạng khác' },
		  { title: 'Không watermark', desc: 'Video sạch không logo hoặc dấu hiệu nào' },
		  { title: 'Không cần đăng ký', desc: 'Sử dụng ngay mà không cần tài khoản hoặc đăng nhập' },
		  { title: 'Tải xuống nhanh', desc: 'Máy chủ được tối ưu cho tốc độ tối đa' },
		  { title: '100% miễn phí', desc: 'Tất cả tính năng miễn phí mãi mãi' },
		],
	  },

	  howItWorks: {
		sectionBadge: 'Cách hoạt động',
		headline: 'Chỉ với 4 bước đơn giản',
		steps: [
		  {
			num: '01',
			title: 'Sao chép liên kết video',
			desc: 'Mở nền tảng yêu thích, tìm video muốn tải rồi sao chép URL.',
		  },
		  {
			num: '02',
			title: 'Dán vào GrabWatch',
			desc: 'Dán liên kết video và GrabWatch sẽ tự động nhận diện nền tảng.',
		  },
		  {
			num: '03',
			title: 'Chọn định dạng & chất lượng',
			desc: 'Chọn MP4 4K, MP3 hoặc định dạng khác phù hợp.',
		  },
		  {
			num: '04',
			title: 'Tải xuống & thưởng thức',
			desc: 'Nhấn tải xuống và file sẽ được lưu trực tiếp vào thiết bị.',
		  },
		],
	  },

	  faq: {
		sectionBadge: 'FAQ',
		headline: 'Câu hỏi thường gặp',
		items: [
		  {
			q: 'GrabWatch có thực sự miễn phí không?',
			a: 'Có, GrabWatch hoàn toàn miễn phí cho mọi người dùng.',
		  },
		  {
			q: 'Hỗ trợ những nền tảng nào?',
			a: 'GrabWatch hỗ trợ YouTube, Instagram, Threads, Facebook, X/Twitter, TikTok và Doodstream.',
		  },
		  {
			q: 'Tôi có cần tạo tài khoản không?',
			a: 'Không cần đăng ký hay đăng nhập.',
		  },
		  {
			q: 'Có những định dạng nào?',
			a: 'Hỗ trợ MP4, MP3 và WebM.',
		  },
		  {
			q: 'Có thể tải video riêng tư không?',
			a: 'Không. Chỉ hỗ trợ video công khai.',
		  },
		  {
			q: 'Có giới hạn tải xuống không?',
			a: 'Không có giới hạn nghiêm ngặt cho phiên bản miễn phí.',
		  },
		],
	  },

	  footer: {
		tagline: 'Tải video miễn phí, nhanh chóng và an toàn.',
		columns: [
		  {
			title: 'Nền tảng',
			links: ['YouTube', 'Instagram', 'Threads', 'Facebook', 'TikTok', 'X / Twitter', 'Doodstream'],
		  },
		  {
			title: 'Sản phẩm',
			links: ['Tiện ích Chrome', 'Phiên bản Pro', 'API Docs', 'Changelog'],
		  },
		  {
			title: 'Hỗ trợ',
			links: ['Hướng dẫn', 'FAQ', 'Trạng thái máy chủ', 'Liên hệ'],
		  },
		],
		copyright: '© 2025 GrabWatch.',
		legal: ['Quyền riêng tư', 'Điều khoản', 'Cookie'],
	  },

	  lang: {
		toggle: 'EN',
		label: 'Tiếng Việt'
	  },
	},

	
	
	// Chinese (Simplified)
	zh: {
	  langid : 'zh',
	  title: "免费视频下载器 – 快速在线视频下载 | Grab&Watch",
	  desc: "使用 Grabw.com 免费下载在线视频。快速、简单、高清的视频下载工具，支持 TikTok、Instagram、Threads、Facebook、X、YouTube Shorts、Popweb、VidGF、Vidara、Doodstream 等平台。",
	  keywords: "视频下载器, youtube下载器, instagram下载器, tiktok下载器, facebook视频下载, twitter视频下载, doodstream下载器, 在线视频下载, 免费视频下载, mp4下载器, 无水印, 4k视频下载, 无水印下载tiktok",

	  nav: {
		features: '功能',
		platforms: '平台',
		howItWorks: '使用方法',
		faq: 'FAQ',
		tryPro: '试用 Pro',
	  },

	  hero: {
		badge: '免费且无限下载',
		headline1: '从任何平台',
		headline2: '下载视频',
		subheadline: '粘贴来自 YouTube、Instagram、Threads、TikTok、Facebook、X/Twitter 或 Doodstream 的链接，几秒内即可下载。',
		placeholder: {
		  all: '粘贴任意平台的视频链接...',
		  youtube: 'https://youtube.com/watch?v=...',
		  instagram: 'https://instagram.com/p/...',
		  threads: 'https://threads.com/...',
		  facebook: 'https://facebook.com/watch?v=...',
		  tiktok: 'https://tiktok.com/@user/video/...',
		  twitter: 'https://x.com/user/status/...',
		  doodstream: 'https://dood.watch/d/...',
		},
		pasteBtn: '粘贴',
		downloadBtn: '下载',
		hint: '支持 MP4 · MP3 · WebM · 最高 4K · 无水印',
		supportedLabel: '支持的平台',
		stats: [
		  { num: '10M+', label: '已下载视频' },
		  { num: '7', label: '支持的平台' },
		  { num: '4K', label: '最高分辨率' },
		  { num: '100%', label: '永久免费' },
		],
		toastPaste: '✓ 链接粘贴成功',
		toastPasteAlt: '使用 Ctrl+V 粘贴',
		toastEmpty: '⚠ 请先输入视频链接',
		toastInvalid: '⚠ 链接必须以 https:// 开头',
		toastSuccess: '✓ 正在下载视频...',
	  },

	  modal: {
		title: '下载器',
		stages: [
		  '正在分析链接...',
		  '正在获取视频信息...',
		  '视频已准备好下载！'
		],
		formatLabel: '选择格式',
		downloadBtn: '下载',
	  },

	  features: {
		sectionBadge: '为什么选择 GrabWatch？',
		headline: '所有功能完全免费',
		sub: '免费下载视频所需的一切功能。',
		items: [
		  { title: '高清分辨率', desc: '支持下载 4K、1080p、720p 等画质' },
		  { title: '多种格式', desc: '支持 MP4、MP3、WebM 等格式' },
		  { title: '无水印', desc: '视频干净无任何标志' },
		  { title: '无需注册', desc: '无需账号即可直接使用' },
		  { title: '高速下载', desc: '服务器针对高速下载进行了优化' },
		  { title: '100% 免费', desc: '所有功能永久免费使用' },
		],
	  },

	  howItWorks: {
		sectionBadge: '使用方法',
		headline: '只需 4 个简单步骤',
		steps: [
		  {
			num: '01',
			title: '复制视频链接',
			desc: '打开你喜欢的平台，找到视频并复制其 URL。',
		  },
		  {
			num: '02',
			title: '粘贴到 GrabWatch',
			desc: '粘贴视频链接，GrabWatch 将自动识别平台。',
		  },
		  {
			num: '03',
			title: '选择格式和画质',
			desc: '选择 MP4 4K、MP3 或其他可用格式。',
		  },
		  {
			num: '04',
			title: '下载并享受',
			desc: '点击下载，文件将直接保存到你的设备。',
		  },
		],
	  },

	  faq: {
		sectionBadge: 'FAQ',
		headline: '常见问题',
		items: [
		  {
			q: 'GrabWatch 真的是免费的吗？',
			a: '是的，GrabWatch 对所有用户完全免费。',
		  },
		  {
			q: '支持哪些平台？',
			a: '支持 YouTube、Instagram、Threads、Facebook、X/Twitter、TikTok 和 Doodstream。',
		  },
		  {
			q: '需要注册账号吗？',
			a: '不需要注册或登录。',
		  },
		  {
			q: '支持哪些格式？',
			a: '支持 MP4、MP3 和 WebM。',
		  },
		  {
			q: '可以下载私人视频吗？',
			a: '不可以，仅支持公开视频。',
		  },
		  {
			q: '下载次数有限制吗？',
			a: '免费版本没有严格的下载限制。',
		  },
		],
	  },

	  footer: {
		tagline: '免费、快速、安全地下载视频。',
		columns: [
		  {
			title: '平台',
			links: ['YouTube', 'Instagram', 'Threads', 'Facebook', 'TikTok', 'X / Twitter', 'Doodstream'],
		  },
		  {
			title: '产品',
			links: ['Chrome 扩展', 'Pro 版本', 'API Docs', '更新日志'],
		  },
		  {
			title: '帮助',
			links: ['指南', 'FAQ', '服务器状态', '联系我们'],
		  },
		],
		copyright: '© 2025 GrabWatch.',
		legal: ['隐私政策', '条款与条件', 'Cookie'],
	  },

	  lang: {
		toggle: 'EN',
		label: '中文'
	  },
	},

	// Japanese
	ja: {
	  langid : 'ja',
	  title: "無料オンライン動画ダウンローダー – 高速動画ダウンロード | Grab&Watch",
	  desc: "Grabw.comで動画を無料ダウンロード。TikTok、Instagram、Threads、Facebook、X、YouTube Shorts、Popweb、VidGF、Vidara、Doodstreamなどに対応した高速・簡単・HD品質の動画ダウンローダー。",
	  keywords: "動画ダウンローダー, youtubeダウンローダー, instagramダウンローダー, tiktokダウンローダー, facebook動画ダウンロード, twitter動画ダウンロード, doodstreamダウンローダー, オンライン動画ダウンロード, 無料動画ダウンローダー, mp4ダウンローダー, ウォーターマークなし, 4k動画ダウンロード, tiktok透かしなしダウンロード",

	  nav: {
		features: '機能',
		platforms: 'プラットフォーム',
		howItWorks: '使い方',
		faq: 'FAQ',
		tryPro: 'Pro を試す',
	  },

	  hero: {
		badge: '無料・無制限ダウンロード',
		headline1: '動画をダウンロード',
		headline2: 'あらゆるプラットフォームから',
		subheadline: 'YouTube、Instagram、Threads、TikTok、Facebook、X/Twitter、Doodstream のリンクを貼り付けるだけで、数秒でダウンロードできます。',
		placeholder: {
		  all: '任意のプラットフォームの動画リンクを貼り付け...',
		  youtube: 'https://youtube.com/watch?v=...',
		  instagram: 'https://instagram.com/p/...',
		  threads: 'https://threads.com/...',
		  facebook: 'https://facebook.com/watch?v=...',
		  tiktok: 'https://tiktok.com/@user/video/...',
		  twitter: 'https://x.com/user/status/...',
		  doodstream: 'https://dood.watch/d/...',
		},
		pasteBtn: '貼り付け',
		downloadBtn: 'ダウンロード',
		hint: 'MP4 · MP3 · WebM · 最大4K · ウォーターマークなし',
		supportedLabel: '対応プラットフォーム',
		stats: [
		  { num: '10M+', label: 'ダウンロード済み動画' },
		  { num: '7', label: '対応プラットフォーム' },
		  { num: '4K', label: '最大解像度' },
		  { num: '100%', label: '完全無料' },
		],
		toastPaste: '✓ リンクを貼り付けました',
		toastPasteAlt: 'Ctrl+V で貼り付け',
		toastEmpty: '⚠ 動画リンクを入力してください',
		toastInvalid: '⚠ リンクは https:// で始まる必要があります',
		toastSuccess: '✓ 動画をダウンロード中...',
	  },

	  modal: {
		title: 'ダウンローダー',
		stages: [
		  'リンクを解析中...',
		  '動画情報を取得中...',
		  '動画の準備が完了しました！'
		],
		formatLabel: '形式を選択',
		downloadBtn: 'ダウンロード',
	  },

	  features: {
		sectionBadge: 'なぜ GrabWatch？',
		headline: 'すべての機能が完全無料',
		sub: '動画ダウンロードに必要なすべてを無料で提供。',
		items: [
		  { title: '高解像度', desc: '4K、1080p、720p に対応' },
		  { title: '複数形式対応', desc: 'MP4、MP3、WebM などを選択可能' },
		  { title: 'ウォーターマークなし', desc: 'ロゴなしのクリーンな動画' },
		  { title: '登録不要', desc: 'アカウント不要ですぐ利用可能' },
		  { title: '高速ダウンロード', desc: '高速サーバーで快適ダウンロード' },
		  { title: '100%無料', desc: 'すべての機能を永久無料で利用可能' },
		],
	  },

	  howItWorks: {
		sectionBadge: '使い方',
		headline: '簡単4ステップ',
		steps: [
		  {
			num: '01',
			title: '動画リンクをコピー',
			desc: '好きなプラットフォームで動画URLをコピーします。',
		  },
		  {
			num: '02',
			title: 'GrabWatch に貼り付け',
			desc: 'リンクを貼り付けると自動で解析されます。',
		  },
		  {
			num: '03',
			title: '形式と画質を選択',
			desc: 'MP4 4K、MP3 など必要な形式を選択。',
		  },
		  {
			num: '04',
			title: 'ダウンロード開始',
			desc: 'ダウンロードボタンを押して保存。',
		  },
		],
	  },

	  faq: {
		sectionBadge: 'FAQ',
		headline: 'よくある質問',
		items: [
		  {
			q: 'GrabWatch は本当に無料ですか？',
			a: 'はい、完全無料です。',
		  },
		  {
			q: '対応プラットフォームは？',
			a: 'YouTube、Instagram、Threads、Facebook、X/Twitter、TikTok、Doodstream に対応。',
		  },
		  {
			q: 'アカウント登録は必要ですか？',
			a: '登録不要です。',
		  },
		  {
			q: '利用可能な形式は？',
			a: 'MP4、MP3、WebM に対応。',
		  },
		  {
			q: '非公開動画もダウンロードできますか？',
			a: 'いいえ、公開動画のみ対応。',
		  },
		  {
			q: 'ダウンロード制限はありますか？',
			a: '無料版に厳しい制限はありません。',
		  },
		],
	  },

	  footer: {
		tagline: '無料・高速・安全な動画ダウンロード。',
		columns: [
		  {
			title: 'プラットフォーム',
			links: ['YouTube', 'Instagram', 'Threads', 'Facebook', 'TikTok', 'X / Twitter', 'Doodstream'],
		  },
		  {
			title: '製品',
			links: ['Chrome 拡張機能', 'Pro バージョン', 'API Docs', 'Changelog'],
		  },
		  {
			title: 'サポート',
			links: ['ガイド', 'FAQ', 'サーバーステータス', 'お問い合わせ'],
		  },
		],
		copyright: '© 2025 GrabWatch.',
		legal: ['プライバシー', '利用規約', 'Cookie'],
	  },

	  lang: {
		toggle: 'EN',
		label: '日本語'
	  },
	}
  
  
  
};
